<script lang="ts">
  import LoadingIndicator from "./LoadingIndicator.svelte";

  export let text: string | undefined = undefined;
</script>

<div class="w-full h-full flex justify-center items-center pt-32 lg:pt-0" data-testid="loading">
  <LoadingIndicator />
  {#if text}
    <p>{text}</p>
  {/if}
</div>
